export default __webpack_public_path__ + "static/media/onboarding_filter.805092b9.jpg";